import { boolean, object, string, ObjectSchema } from 'yup';

import { PersonMinimalFormValues } from '@/forms/PersonMinimalForm/types';

export const personMinimalSchema: ObjectSchema<PersonMinimalFormValues> = object({
  email: string().trim(),
  exclude_from_analytics: boolean(),
  first_name: string().trim().required('First name is required'),
  last_name: string().trim(),
  phone: string().trim()
});
